import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER_SETTINGS_NOTIFICATIONS } from '@/api/endpoints';
import { NOTIFICATION_SETTINGS_QUERY_KEY } from '@/api/queryKeys';
import type { NotificationSettingsResponse } from '@/types/notifications';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

const STALE_TIME_MS = 10_000;

export const useNotificationSettings = (userPublicId?: string) =>
  useQuery<NotificationSettingsResponse>({
    queryKey: [...NOTIFICATION_SETTINGS_QUERY_KEY, userPublicId],
    queryFn: () =>
      apiClient
        .get<NotificationSettingsResponse>(
          joinPath(API_USER_SETTINGS_NOTIFICATIONS, userPublicId ?? ''),
        )
        .then(unwrapAxiosResponse),
    enabled: !!userPublicId,
    staleTime: STALE_TIME_MS,
  });
